export enum SidebarTypes {
  Row,
  Column,
}

export enum NavigationExpandModes {
  AllOpen,
  AllClosed,
  CurrentOpen,
}
